import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

import ProgrammingFilterComponent from './ProgrammingFilterComponent'
import MediaTypeFilterComponent from './MediaTypeFilterComponent'
import AnticipationMediaTypeFilterComponent from './AnticipationMediaTypeFilterComponent'
import GenreFilterComponent from './GenreFilterComponent'
import BrandFilterComponent from './BrandFilterComponent'
import OtherFilterComponent from './OtherFilterComponent'
import { MediaPrefrence, PlanFilters } from '../../../classes/FilterHelpers'
import EntitlementAccessHelper from '../../../classes/EntitlementAccessHelper'
import { CURRENT_FILTER, ANTICIPATION, ANTICIPATION_FILTER, FILTER_MODE_NEW, FILTER_MODE_RESET, FILTER_MODE_APPLY } from '../../../constants/commons'
import { MEDIA_PREFERENCE, BRAND_PREFERENCE, DEMOGRAPHICS } from '../../../constants/commons'
import * as f from '../../../classes/Filters'

export default class AudienceFilterComponent extends React.Component {
  static propTypes = {
    filterIcon: PropTypes.bool.isRequired,
    filters: PropTypes.object.isRequired,
    selectedPlanFilters: PropTypes.object.isRequired,
    programmingFilters: PropTypes.array.isRequired,
    otherFilters: PropTypes.array,
    setFilters: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    setFilterIcon: PropTypes.func.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    shortcutPreference: PropTypes.string,
    fetchTopicPlan: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.state = {
      filterIcon: false
    }
  }

  componentDidUpdate (prevProps){
    if (prevProps.filterIcon !== this.props.filterIcon) {
      this.setState({ filterIcon: this.props.filterIcon })
    }
  }

  render () {
    const tableFilter = () => {
      this.setState({ filterIcon: !this.state.filterIcon })
    }
    const module = this.props.location && (this.props.location.pathname.includes(MEDIA_PREFERENCE)) ? MEDIA_PREFERENCE
      : this.props.location && (this.props.location.pathname.includes(DEMOGRAPHICS)) ? DEMOGRAPHICS : ''
    const pathname = this.props.location ? this.props.location.pathname : ''
    const selectedModule = EntitlementAccessHelper.getCurrentModule(pathname)
    return (
      <Modal isOpen={this.state.filterIcon} toggle={tableFilter} className='popupUI' onClosed={this.props.setFilterIcon}>
        <ModalHeader toggle={tableFilter}>Filters</ModalHeader>
        <ModalBody>
          { ((this.props.shortcut && (this.props.shortcutPreference === MEDIA_PREFERENCE)) || (this.props.location && (this.props.location.pathname.includes(MEDIA_PREFERENCE)))) &&
            <Row>
              <Col>
                <MediaTypeFilterComponent
                  setFilters= {this.props.setFilters}
                  filters={this.props.filters}
                  selectedPlanFilters={this.props.selectedPlanFilters}
                  module={MEDIA_PREFERENCE}
                />
                <ProgrammingFilterComponent
                  setFilters= {this.props.setFilters}
                  programmingFilters= {this.props.programmingFilters}
                  module={MEDIA_PREFERENCE}
                />
                <OtherFilterComponent
                  filters={this.props.filters}
                  setFilters= {this.props.setFilters}
                  otherFilters={this.props.otherFilters}
                  module={module}
                />
              </Col>
              <Col>
                <GenreFilterComponent
                  setFilters= {this.props.setFilters}
                  filters={this.props.filters}
                  selectedPlanFilters={this.props.selectedPlanFilters}
                  module={MEDIA_PREFERENCE}
                />
              </Col>
            </Row>
          }
          { ((this.props.shortcut && (this.props.shortcutPreference === DEMOGRAPHICS)) || (this.props.location && (this.props.location.pathname.includes(DEMOGRAPHICS)))) &&
            <Row>
              <Col>
                <OtherFilterComponent
                  filters={this.props.filters}
                  setFilters= {this.props.setFilters}
                  otherFilters={this.props.otherFilters}
                  module={module}
                />
              </Col>
            </Row>
          }
          { ((this.props.shortcut && this.props.shortcutPreference === BRAND_PREFERENCE) || (this.props.location && this.props.location.pathname.includes(BRAND_PREFERENCE))) &&
            <Row>
              <Col>
                <BrandFilterComponent
                  setFilters= {this.props.setFilters}
                  filters={this.props.filters}
                  selectedPlanFilters={this.props.selectedPlanFilters}
                  module={BRAND_PREFERENCE}
                />
              </Col>
              <Col>
                <OtherFilterComponent
                  filters={this.props.filters}
                  setFilters= {this.props.setFilters}
                  otherFilters={this.props.otherFilters}
                  module={BRAND_PREFERENCE}
                />
              </Col>
            </Row>
          }
          { ((this.props.shortcut && this.props.shortcutPreference === ANTICIPATION) || (this.props.location && this.props.location.pathname.includes(ANTICIPATION))) &&
            <Row>
              <Col>
                <AnticipationMediaTypeFilterComponent
                  setFilters= {this.props.setFilters}
                  filters={this.props.filters}
                  selectedPlanFilters={this.props.selectedPlanFilters}
                  module={ANTICIPATION}
                />
              </Col>
              <Col>
                <GenreFilterComponent
                  setFilters= {this.props.setFilters}
                  filters={this.props.filters}
                  selectedPlanFilters={this.props.selectedPlanFilters}
                  module={ANTICIPATION}
                />
              </Col>
            </Row>
          }
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button className='cancel' onClick={this.deselectFilter}>Clear</Button>
            </Col>
            <Col>
              <Button className='reset' onClick={() => this.resetFilter(selectedModule)}>Reset</Button>
            </Col>
            <Col>
              <Button className='apply' onClick={() => this.applyFilter(selectedModule)}>Apply</Button>
            </Col>
          </Row></ModalFooter>
      </Modal>
    )
  }

  deselectFilter = (module) => {
    this.props.setFilters(f.Filters.Common.Empty, CURRENT_FILTER, null, 'deselect')
    setTimeout(() => {
      this.props.fetchTopicPlan(module)
    }, 500)
  }

  resetFilter = (module) => {
    if (this.props.location.pathname.includes(DEMOGRAPHICS)) {
      this.props.setFilters(PlanFilters.Lifestyle, CURRENT_FILTER, DEMOGRAPHICS, FILTER_MODE_RESET)
    } else if (this.props.location.pathname.includes(BRAND_PREFERENCE)) {
      this.props.setFilters(PlanFilters.Brand, CURRENT_FILTER, BRAND_PREFERENCE, FILTER_MODE_RESET)
    } else if (this.props.location.pathname.includes(ANTICIPATION)) {
      this.props.resetFilters()
      this.props.setFilters(f.Filters.Common.AnticipationShowMovie, ANTICIPATION_FILTER, ANTICIPATION, FILTER_MODE_NEW)
    } else {
      this.props.setFilters(MediaPrefrence, CURRENT_FILTER, MEDIA_PREFERENCE, FILTER_MODE_RESET)
    }
    setTimeout(() => {
      this.props.fetchTopicPlan(module, FILTER_MODE_RESET)
    }, 500)
  }

  applyFilter = (module) => {
    this.props.fetchTopicPlan(module, FILTER_MODE_APPLY)
    this.setState({ filterIcon: false })
  }
}
